module.exports = __webpack_public_path__ + "static/media/default_header.38637433.jpg";